var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.16,
    x: 0.299957,
    y: 0.840431,
    width: 149.971,
    height: 149.971,
    rx: 74.9857,
    fill: "#FD5F59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.851,
    y: 31.3903,
    width: 88.8719,
    height: 88.8719,
    rx: 44.436,
    fill: "#FD5F59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2854 69.6314V77.8891M75.2854 84.0824V84.1031M56.7054 75.8247C56.7054 78.2646 57.186 80.6807 58.1198 82.9349C59.0535 85.1891 60.4221 87.2374 62.1474 88.9627C63.8727 90.688 65.9209 92.0566 68.1752 92.9903C70.4294 93.924 72.8454 94.4046 75.2854 94.4046C77.7254 94.4046 80.1414 93.924 82.3956 92.9903C84.6499 92.0566 86.6981 90.688 88.4234 88.9627C90.1487 87.2374 91.5173 85.1891 92.4511 82.9349C93.3848 80.6807 93.8654 78.2646 93.8654 75.8247C93.8654 73.3847 93.3848 70.9687 92.4511 68.7144C91.5173 66.4602 90.1487 64.412 88.4234 62.6867C86.6981 60.9613 84.6499 59.5928 82.3956 58.659C80.1414 57.7253 77.7254 57.2447 75.2854 57.2447C72.8454 57.2447 70.4294 57.7253 68.1752 58.659C65.9209 59.5928 63.8727 60.9613 62.1474 62.6867C60.4221 64.412 59.0535 66.4602 58.1198 68.7144C57.186 70.9687 56.7054 73.3847 56.7054 75.8247Z",
    stroke: "white",
    strokeWidth: 4.27126,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.dafd20dce3dbe56871c375c1ede51891.svg";
export { ForwardRef as ReactComponent };